import { render, staticRenderFns } from "./CourseTypeForm.vue?vue&type=template&id=5facb91a&"
import script from "./CourseTypeForm.vue?vue&type=script&lang=js&"
export * from "./CourseTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseTypeForm.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports